module.exports = __webpack_public_path__ + "images/cos-logo-ca5e3aa42c0744490ecbff4546569bc4.svg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/cos-logo.svg
// module id = 192
// module chunks = 0